module.exports = __webpack_public_path__ + "img/card.a4b3263a.svg";